{ getSeparatorClassName } = require 'app/scripts/views/card/SeparatorCard/SeparatorCard'
cardTitleTemplate = require 'app/scripts/views/templates/card_title_on_card_front'
Util = require 'app/scripts/lib/util'
PopOver = require 'app/scripts/views/lib/pop-over'
QuickCardEditorView = require 'app/scripts/views/card/quick-card-editor-view'
{ track } = require '@trello/analytics'

module.exports.renderName = ->
  data = @model.toJSON()
  data.separatorClassName = getSeparatorClassName(data.name)

  html = cardTitleTemplate(data)

  @$('.js-card-name').html html

  @

module.exports.openQuickCardEditor = (e) ->
  if @options.quickEditHidden || !@model.editable()
    return

  Util.stop(e)
  PopOver.hide()
  QuickCardEditorView.open(@)
  track("Card Front", "Open Quick Card Editor", undefined, @model.trackProperty())

  @
